/********************************************
* Cursor parallax
********************************************/

function fnMagnetize( oElement, event ) {

	// Initialise on mouse movement
    if ( $( window ).width() > 1024 ) {

		$( document ).on( 'mousemove', function( e ) {
			fnMagnetizeInit( '.magnet', e );
		});

    }

}

	function fnMagnetizeInit( oElement, event ) {

		// Mouse position
		var iPositionX              = event.pageX,
			iPositionY              = event.pageY;

		// Items
		var oElements               = $( oElement );

		oElements.each( fnMagnetItem );

		function fnMagnetItem( i, oElement ) {

			var oElement            = $( oElement );

			// Distances
			var iCustomDist     	= oElement.data( 'dist' ) * 20 || 120,
				iElemCenterX        = oElement.offset().left + ( oElement.outerWidth() / 2 ),
				iElemCenterY        = oElement.offset().top + ( oElement.outerHeight() / 2 ),
				iElemNewPosX        = Math.floor( ( iElemCenterX - iPositionX ) ) * -0.3,
				iElemNewPosY        = Math.floor( ( iElemCenterY - iPositionY ) ) * -0.3,
				iDistance           = fnMagnetizeDistance( oElement, iPositionX, iPositionY ),
				bScale     			= oElement.data( 'scale' ),
				iScale				= 1;

			if ( bScale == true ) {
				iScale				= 1.075;
			}

			if ( iDistance < iCustomDist ) {

				gsap.to( oElement, {y: iElemNewPosY, x: iElemNewPosX, scale: iScale, duration: .3} );
				oElement.addClass( 'attached' );

			} else {

				gsap.to( oElement, {y: 0, x: 0, scale: 1, duration: .3});
				oElement.removeClass( 'attached' );

			}

		}

	}

	function fnMagnetizeDistance( oElement, iMouseX, iMouseY ) {

		var oElement                = $( oElement );

		return Math.floor(
			Math.sqrt(
				Math.pow( iMouseX - ( oElement.offset().left + ( oElement.outerWidth() / 2 ) ), 2 ) + Math.pow( iMouseY - ( oElement.offset().top + ( oElement.outerHeight() / 2 ) ), 2 )
			)
		);

	}


// END OF DOCUMENT
